




















import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import {IJourneyDetails, LegRecord, OutboundJourneySubset, Stop, TrainRecord} from "./JourneyDetails";
import {CrsConverter} from "./CrsConverter";
import LegSummary from "./LegSummary.vue";
import Accordion from "./Accordion.vue";
import {DateTime} from "luxon";

@Component({
    components: {Accordion, LegSummary}
})
export default class JourneySummary extends Vue {
    @Prop() details: IJourneyDetails;
    @Prop() crsConverter: CrsConverter;

    legsShowingFull: Array<number> = [];

    getDate(dt: string): string {
        const date = DateTime.fromISO(dt);
        return date.toFormat('dd/MM/yyyy');
    }

    get journeyTitle() {
        let last = this.outboundJourney[this.outboundJourney.length-1];
        return this.crsConverter.mapToName(this.outboundJourney[0].originCRS) + " to " + this.crsConverter.mapToName(last.destinationCRS);
    }

    get outboundJourney(): Array<AugmentedLeg> {
        // TODO: In what circumstances can there be more than one outbound journey?
        let journeys = this.details.JourneyPlannerResults.outboundJourneys;
        if (journeys.length === 0) return null;
        const journeySubset: OutboundJourneySubset = journeys[0];
        return this.augmentLegsWithTrainRecords(journeySubset);
    }

    get returnJourney(): Array<AugmentedLeg> {
        // TODO: In what circumstances can there be more than one return journey?
        let journeys = this.details.JourneyPlannerResults.returnJourneys;
        if (journeys.length === 0) return null;
        const journeySubset: OutboundJourneySubset = journeys[0];
        return this.augmentLegsWithTrainRecords(journeySubset);
    }

    private augmentLegsWithTrainRecords(journeySubset: OutboundJourneySubset) {
        const legIds = journeySubset.legs.map(l => l.legRecordID);
        const legs: Array<AugmentedLeg> = this.details.JourneyPlannerResults.legRecords.filter(
            lr => legIds.some(li => li == lr.legRecordID)
        ) as Array<AugmentedLeg>;
        const compareFn = (a, b) => (new Date(a.originDepartTime).getTime() > new Date(b.originDepartTime).getTime()) ? 1 : -1;
        for (let leg of legs.sort(compareFn)) {
            leg.trainRecord = this.details.JourneyPlannerResults.trainRecords.find(
                tr => tr.trainRecordID == leg.trainRecordID
            );

            if (leg.trainRecord) {
                const startTimeDepart = new Date(leg.originDepartTime);
                const endTimeArrive = new Date(leg.destinationArriveTime);

                leg.trainRecord.stops = leg.trainRecord.stops.filter(
                    s => new Date(this.getApplicableTimeForStop(true, s)) <= endTimeArrive &&
                        new Date(this.getApplicableTimeForStop(false, s)) >= startTimeDepart
                );

            }
        }
        return legs;
    }

    mounted() {
        console.log(this.details);
    }

    getApplicableTimeForStop(prefersArrival: boolean, stop: Stop): string {
        if (prefersArrival) {
            return stop.arriveTime.indexOf('0001-01-01') === -1 ? stop.arriveTime : stop.departTime;
        } else {
            return stop.departTime.indexOf('0001-01-01') === -1 ? stop.departTime : stop.arriveTime
        }
    }
}

export class AugmentedLeg implements LegRecord {
    destinationArriveTime: Date;
    destinationCRS: string;
    legRecordID: number;
    liveStatus: string;
    minMaxZone: string;
    mode: string;
    notes: string;
    originCRS: string;
    originDepartTime: Date;
    trainRecordID: number;
    trainRecord: TrainRecord;
}

